import { combineLatest } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { context$ } from 'streams/context/context$';
import { components$ } from 'streams/components/components$';
import type { APIComponentAttributes } from '@ardoq/api-types';

const checkIsWorkspaceEmpty = (
  workspaceId: string,
  components: APIComponentAttributes[]
) => {
  if (!workspaceId) {
    return true;
  }
  return !components.some(component => component.rootWorkspace === workspaceId);
};

export const isContextWorkspaceEmpty$ = combineLatest([
  context$,
  components$,
]).pipe(
  map(([context, components]) => ({
    isContextWorkspaceEmpty: checkIsWorkspaceEmpty(
      context.workspaceId,
      components.models
    ),
  })),
  distinctUntilChanged(
    (a, b) => a.isContextWorkspaceEmpty === b.isContextWorkspaceEmpty
  )
);
